
import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import NotificationLangs from "./_langs";
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";
import TranslateButton from "../../../components/buttons/TranslateButton";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {PH_CODE,} from "../../../components/i18n/placeHolders"
import {
    INTERNATIONAL,
    REQUIRED,
} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {notificationsService} from "../../../jwt/_services/comunication/notificationsService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";


// providers
import {applicativeProvider} from "../../../providers/applicativeProvider";
import {udnProvider} from "../../../providers/udnProvider";



const NotificationForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app
    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setLang] = useState(domainObject?.langs || []);
    const [applicative, setApplicative] = useState(domainObject?.applicative?.id || null);
    const [udn, setUdn] = useState(domainObject?.udn?.id || null);


    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                langs
            }
        };


        if(status !== undefined && status !== null)
            dataRequest.item.status = status;

        if(applicative !== undefined && applicative !== null)
            dataRequest.item.applicative = {id: applicative};

        if(udn !== undefined && udn !== null)
            dataRequest.item.udn = {id: udn};


        if (!editMode)
            genericIndexedActions.save(path, notificationsService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, notificationsService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                            <TranslateButton item={domainObject} service={notificationsService} />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{'Código de la notificación'}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                            {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <SelectGeneric
                                title={'¿A qué aplicación a la que se enviará?'}
                                initialValue={applicative}
                                setExternalValue={setApplicative}
                                provider={applicativeProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <SelectGeneric
                                title={'¿A qué unidad de negocio?'}
                                initialValue={udn}
                                setExternalValue={setUdn}
                                provider={udnProvider}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{'¿La notificación esta activa?'}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="fas fa-language mr-2"/>
                    { INTERNATIONAL }
                </CardTitle>
                <CardBody>
                    <NotificationLangs
                        langs={langs}
                        setLangs={setLang}
                        translatableLangs={translatableLangs}
                    />
                </CardBody>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default NotificationForm